import { css } from "@emotion/react";

export const appleButton = css`
  margin-top: 1rem;
`;
